/**
 * Destino del QR de la etiqueta.
 *
 * La etiqueta pegada en un extintor lleva `https://…/q/<token>`. Escanearla
 * con la cámara del móvil trae aquí, y esta pantalla traduce el token opaco
 * al equipo y lleva a su ficha.
 *
 * El token **no** dice de quién es la instalación: la resolución es pública
 * pero sólo devuelve el identificador del equipo y su empresa (SECURITY.md
 * §7). Ver la ficha exige sesión, y de eso ya se encarga el enrutador.
 */

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSession } from '../session/session-context.js';

export function QrResolveScreen(): React.ReactNode {
  const { token } = useParams();
  const navigate = useNavigate();
  const { api } = useSession();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;

    api
      .get<{ equipmentId: string }>(`/qr/${token}`)
      .then((found) => {
        // `replace` y no `push`: quien vuelva atrás desde la ficha del equipo
        // debe salir del flujo, no rebotar otra vez contra el resolutor.
        if (!cancelled) navigate(`/equipos/${found.equipmentId}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) {
          setError(
            'Esta etiqueta no corresponde a ningún equipo. Puede que se haya sustituido el equipo o que la etiqueta sea de otra empresa.',
          );
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token, api, navigate]);

  return (
    <section className="screen">
      <h2 className="screen__title">Etiqueta</h2>
      {error === null ? (
        <p className="screen__note">Buscando el equipo…</p>
      ) : (
        <p className="screen__error" role="alert">
          {error}
        </p>
      )}
    </section>
  );
}
